<template>

  <div class="help-panels">

    <v-expansion-panels tile>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.createOrder.whyTokenNotFound.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.createOrder.whyTokenNotFound.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>
         {{ $t('helpContents.createOrder.whyTokenNotSelectableForSelling.title') }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-html="$t('helpContents.createOrder.whyTokenNotSelectableForSelling.contents')"></div>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>


  </div>


</template>

<script>

export default {
  name: 'CreateOrderHelp',
  props: {
  },
  data () {
    return {
    }
  },
}
</script>


<style scoped>

</style>
